import {TreeNode} from "../types/Post";
import {CATEGORIES} from "./constants";

/** 在樹中找節點並回傳 root → 目標 的路徑 */
export function buildBreadcrumbFromTree(
  roots: TreeNode[],
  targetId: string
): TreeNode[] {
  for (const r of roots) {
    const path = dfs(r, targetId);
    if (path.length) return path;
  }
  return [];
}

export const buildTreeFromFlat = (items: any[]): TreeNode[] => {
  const map: Record<string, TreeNode> = {};

  items.forEach((item) => {
    map[item.id] = {
      id: item.id,
      name: item.name,
      coverImageUrl: item.coverImageUrl || "",
      level: item.level || 1,
      parentId: item.parentId || null,
      children: [],
    };
  });

  const roots: TreeNode[] = [];
  items.forEach((item) => {
    const node = map[item.id];
    if (item.parentId && map[item.parentId]) {
      map[item.parentId].children.push(node);
    } else {
      roots.push(node);
    }
  });

  return [
    {
      id: "",
      name: "/",
      level: 0,
      parentId: null,
      children: roots,
    },
  ];
};

export const filterPostsByCategory = (posts, category) => {
  // 收集該節點底下所有 level=3 id
  const l3Ids = new Set<string>();
  const walk = (n: TreeNode) => {
    if (n.level === 3) l3Ids.add(n.id);
    n.children.forEach(walk);
  };
  walk(category);
  const isL3 = category.level === 3;
  const targetIds = isL3 ? new Set([category.id]) : l3Ids;
  return posts.filter((p) => targetIds.has(p.detailCategoryId));
}

export const dfs = (node: TreeNode, targetId: string): TreeNode[] => {
  if (node.id === targetId) return [node];
  for (const c of node.children || []) {
    const sub = dfs(c, targetId);
    if (sub.length) return [node, ...sub];
  }
  return [];
}

export const findCategoryByLabel = (label: string) => {
  const DEFAULT_CATEGORY = {
    label: label,
    color: 'bg-gray-400',
    badgeColor: 'bg-gray-400',
    icon: null,
  }
  return CATEGORIES.find(category => category.path === label) || DEFAULT_CATEGORY
}
